import { MAX_SMALL_DEVICE_WIDTH } from '~constants/screenSizes';

export const isSmallDevice = () => (window.innerWidth || screen.width) < MAX_SMALL_DEVICE_WIDTH;

export const scssVariableToNumber = variable =>
  variable.endsWith('px') ? parseInt(variable.split('px')[0]) : 0;
